import { render, staticRenderFns } from "./SagePaySlipUploadForm.vue?vue&type=template&id=1041fea9&scoped=true&"
import script from "./SagePaySlipUploadForm.vue?vue&type=script&lang=js&"
export * from "./SagePaySlipUploadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1041fea9",
  null
  
)

export default component.exports